<!-- Loading bar -->
<expepharma-loading-bar></expepharma-loading-bar>

<router-outlet *ngIf="true"></router-outlet>
